const MAX_CACHE_ENTRIES = 100
const cache = new Map()

export function getCachedEventListValue(key) {
  const entry = cache.get(key)
  if (!entry) return null

  if (entry.expiresAt <= Date.now()) {
    cache.delete(key)
    return null
  }

  return entry.value
}

export function setCachedEventListValue(key, value, ttl) {
  cache.set(key, { value, expiresAt: Date.now() + ttl })

  if (cache.size > MAX_CACHE_ENTRIES) cache.delete(cache.keys().next().value)
}

export function eventListCacheKey(type, variables) {
  return `${type}:${JSON.stringify(variables)}`
}
